import NewEventForm from '../../components/NewEventForm/NewEventForm'

const NewEvent = () => {
  return <NewEventForm />
}

export default NewEvent
